const getSectionIdFromUnitId = (unitId = '') => {
    const parts = unitId.split(':');
    const path = parts[0] || '';
    const pathParts = path.split('-');
    const sectionId = pathParts[0] || '';

    return sectionId;
};

export default {
    getSectionIdFromUnitId,
};
